export default function getIsNextCancelledError(error: unknown) {
  return error instanceof Error && "cancelled" in error && error.cancelled;
}
